<div class="form-holder">
  <vc-poll-card-header [image]="'assets/electeurs.svg'" [title]="'POLL-CREATION.VOTERS.TITLE' | translate" [description]="'POLL-CREATION.VOTERS.DESCRIPTION' | translate">
  </vc-poll-card-header>
  <div class="safe-area">
    <mat-button-toggle-group disabled="{{readonly}}" [(ngModel)]="isExcelUpload"  appearance="legacy" (change)="changed($event)" style="border-radius: 6px;">
      <mat-button-toggle id="left-toggle" value="true">{{'POLL-CREATION.VOTERS.EXCEL-BUTTON' | translate}}</mat-button-toggle>
      <mat-button-toggle id="right-toggle" value="false">{{'POLL-CREATION.VOTERS.FAST-IMPORT-BUTTON' | translate}}</mat-button-toggle>
    </mat-button-toggle-group>
    <div [hidden]="isExcelUpload === 'false'">
      <div class="upload-description">{{'POLL-CREATION.VOTERS.UPLOAD-DESCRIPTION' | translate}}</div>
      <button type="button" id="template-download" (click)="openModel()">
        <img src="assets/icon_download.svg" id="model-icon">
        <span>{{'POLL-CREATION.VOTERS.VOTERS-MODEL' | translate}}</span>
      </button>
      <div *ngIf="!isVotersValid">
        <div class="upload-button" (click)="fileInput.click()" appDragDrop (onFileDropped)="onFileDropped($event)">
          <img src="assets/file-excel.png" id="background-button">
          <p class="description-upload">{{'POLL-CREATION.VOTERS.IMPORT' | translate}}</p>
          <input [disabled]="readonly" style="display: none"
            type="file" accept=".xlsx, .xls" (change)="onFileChanged($event); fileInput.value=''" #fileInput>
        </div>
      </div>
      <div *ngIf="isVotersValid" id="resume-holder">
        <p>
          <span id="voters-count">{{votersCountString}}</span>
          <span id="voters-description">{{'POLL-CREATION.VOTERS.VOTERS-DESCRIPTION' | translate}}</span>
        </p>
        <p *ngIf="voterImportDate != undefined" class="change-text" style="margin-left: 24px;">{{'POLL-CREATION.VOTERS.IMPORT-TIME' | translate}}{{voterImportDate}}</p>
        <div id="uploaded-buttons">
          <button type="button" id="display-voters" (click)="displayVoters()">{{'POLL-CREATION.VOTERS.VERIFY' | translate}}</button>
          <div id="file-change" (click)="fileInput.click()">
            <body class="change-text">{{'POLL-CREATION.VOTERS.CHANGE-FILE' | translate}}</body>
            <input [disabled]="readonly" style="display: none"
              type="file" accept=".xlsx, .xls" (change)="onFileChanged($event); fileInput.value=''" #fileInput>
          </div>
        </div>
      </div>
    </div>
    <div [hidden]="isExcelUpload === 'true'">
      <div class="upload-description">{{'POLL-CREATION.VOTERS.IMPORT-DESCRIPTION' | translate}}</div>
      <div *ngFor="let voter of voters; let i = index; trackBy: trackVoter" style="display: flex; justify-content: space-between;  width: 360px">
        <input type="email" class="mail-input" (change)="onMailInput($event, i)" maxlength="255" placeholder="{{'POLL-CREATION.VOTERS.EMAIL-PLACEHOLDER' | translate}}" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,63}$" value = {{voter.email}}>
        <div *ngIf="i != 0" class="delete-container">
          <div class="icon-container">
            <img id="delete-button" (click)="deleteVoter(i)" src="assets/deletebutton.svg">
          </div>
        </div>

      </div>
      <button *ngIf="voters.length < 5" id="add-voter" (click)=addVoter()>
        +&nbsp;&nbsp;&nbsp;&nbsp;{{'POLL-CREATION.VOTERS.ADD-MAIL' | translate}}
      </button>
      <div *ngIf="voters.length >= 4" class="separator"></div>
    </div>
    <h4 class="checkboxes-title">{{'POLL-CREATION.VOTERS.INVITE-TYPE' | translate}}</h4>
    <mat-radio-group [disabled]="readonly" id="invite-group" class="invite-type-radio-group" (change)="setInviteMode($event)" [(ngModel)]="inviteMode">
      <mat-radio-button id="invite-0" value="1">Email</mat-radio-button>
      <p class="description" style="margin-bottom: 8px">Lien envoyé par e-mail</p>
      <mat-radio-button value="2" [disabled]="!paidLicence">Double envoi</mat-radio-button>
      <p [ngClass]="paidLicence ? 'description' : 'description-inactive'" style="margin-bottom: 8px">Lien envoyé par e-mail et par SMS</p>
      <mat-radio-button value="3" [disabled]="!paidLicence">Sécurité renforcée</mat-radio-button>
      <p [ngClass]="paidLicence ? 'description' : 'description-inactive'" style="margin-bottom: 8px">Lien envoyé par e-mail et code de sécurité envoyé par SMS</p>
    </mat-radio-group>
    <h4 class="checkboxes-title" style="margin-top: 12px;">Sécurité</h4>
    <p [hidden]="inviteMode != '3'" style="height: 20px; display: flex"><input type="checkbox" id="change-phone-checkbox" [disabled]="readonly" (change)="changePhoneEditable($event)"><span class="description">     Numéros de téléphone modifiables par le votant</span></p>
    <p style="height: 20px; display: flex"><input [disabled]="readonly" type="checkbox" id="pass-checkbox" (change)="changeSecurityQuestion()" [ngModel]="hasSecurityQuestion"><span class="description">     Ajouter une question défi</span></p>
    <div [hidden]="!hasSecurityQuestion" style="display: flex; justify-content: space-between;">
        <textarea [readonly]="readonly" [hidden]="!hasSecurityQuestion" class="name" (input)="common.autoHeight($event, 10)" maxlength="140" (keyup)="secQuestionInput($event)"
                  placeholder="{{'POLL-CREATION.VOTERS.SEC-QUESTION' | translate}}" value="{{securityQuestion}}"></textarea>
    </div>
    <div [hidden]="!hasSecurityQuestion" [ngClass]="getSecQuestionCharacters() >= 140 ? 'character-counter-red' : 'character-counter'">{{getSecQuestionCharacters()}}/140</div>
    <div style="width: 100%;">
      <h4 class="checkboxes-title" style="margin-top: 15px;">{{'POLL-CREATION.VOTERS.SENDER' | translate}}</h4>
      <div style="display: flex; justify-content: space-between;">
        <textarea [readonly]="readonly" id="sender" class="name" (keyup)="senderInput($event)" (input)="common.autoHeight($event, 10)" maxlength="140"
                  placeholder="{{'POLL-CREATION.VOTERS.SENDER-PLACEHOLDER' | translate}}" value="{{sender}}"></textarea>
      </div>
      <div [ngClass]="sender.length == 140 ? 'character-counter-red' : 'character-counter'">{{sender.length}}/140</div>
      <p class="description" [innerHTML]="'POLL-CREATION.MAIN.SENDER-WARNING' | translate"></p>
    </div>
    <div style="height: 20px;"></div>
  </div>
</div>
